import { Row, Col } from "antd";
import React from "react";

import Tool from "./Tool";

//LAPTOP
import macBook from "../../images/tools/macbook.jpg";
import appleMouse from "../../images/tools/applemouse.jpg";
import earPods from "../../images/tools/earpods.jpg";
import stand from "../../images/tools/stand.jpg";

const Computer = props => {
  return (
    <React.Fragment>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Tool
            title="Macbook Pro 15"
            description="2015"
            link="https://www.apple.com/macbook-pro/specs-2015/"
            image={macBook}
          />
        </Col>
        <Col span={12}>
          <Tool
            title="Magic Mouse v2"
            description="Silver"
            link="https://www.apple.com/shop/product/MLA02LL/A/magic-mouse-2-silver"
            image={appleMouse}
          />
        </Col>
      </Row>
      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={12}>
          <Tool
            title="EarPods"
            description="3.5 mm"
            link="https://www.apple.com/shop/product/MNHF2AM/A/earpods-with-35-mm-headphone-plug"
            image={earPods}
          />
        </Col>
        <Col span={12}>
          <Tool
            title="mStand rain design"
            description="Silver"
            link="http://www.raindesigninc.com/mstand.html"
            image={stand}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Computer;



// WEBPACK FOOTER //
// ./src/components/Tools/Laptop.js